"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _product = require("@/api/product");
var _default2 = require("@/views/canteen/creatProduct/default");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _default = exports.default = {
  data: function data() {
    return {
      headTab: [{
        tit: '商品信息',
        name: '1'
      }, {
        tit: '规格库存',
        name: '2'
      }, {
        tit: '商品详情',
        name: '3'
      }, {
        tit: '其他设置',
        name: '4'
      }],
      form: Object.assign({}, _default2.defaultObj),
      attrInfo: {}
    };
  },
  methods: {
    getData: function getData(res, type) {
      var _this2 = this;
      var info = res;
      console.log(res);
      this.form.content = '';
      this.form = _objectSpread(_objectSpread({}, info), {}, {
        image: this.$selfUtil.setDomain(info.image),
        sliderImages: JSON.parse(info.sliderImage),
        auditstatus: 1
      });
      this.htmlKey++;
      this.labelarr = info.keyword ? info.keyword.split(',') : [];
      if (this.form.categoryId) {
        this.getbrandList();
        this.brandList.push({
          name: '其他',
          id: 0
        });
      }
      if (this.form.couponIds && this.form.couponIds.length) {
        (0, _product.productCouponListApi)().then(function (res) {
          var ids = _this2.form.couponIds.toString();
          var arr = res;
          var obj = {};
          for (var i in arr) {
            obj[arr[i].id] = arr[i];
          }
          var strArr = ids.split(',');
          var newArr = [];
          var _iterator = _createForOfIteratorHelper(strArr),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              if (obj[item]) {
                newArr.push(obj[item]);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          _this2.$set(_this2.form, 'coupons', newArr); //在编辑回显时，让返回数据中的优惠券id，通过接口匹配显示,
        });
      }
      var imgs = JSON.parse(info.sliderImage);
      var imgss = [];
      Object.keys(imgs).map(function (i) {
        imgss.push(_this2.$selfUtil.setDomain(imgs[i]));
      });
      this.form.sliderImages = [].concat(imgss);
      if (info.specType) {
        if (info.attrValueList) {
          info.attrValueList.forEach(function (val) {
            val.image = _this2.$selfUtil.setDomain(val.image);
            val.attrValueShow = JSON.parse(val.attrValue);
            val.attr_arr = val.sku.split(',');
            val.brokerage = val.brokerage || 0;
            val.brokerageTwo = val.brokerageTwo || 0;
            val.vipPrice = val.vipPrice || 0;
          });
          this.ManyAttrValue = [].concat(_toConsumableArray(this.oneFormBatch), _toConsumableArray(info.attrValueList));
        } else {
          if (this.form.attrList.length) {
            this.oneFormBatch[0].image = this.$selfUtil.setDomain(info.image);
          }
        }
      } else {
        this.OneattrValue = info.attrValueList;
      }
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i, status) {
      var _this = this;
      if (_this.isDisabled) return;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (tit === '1' && !num) {
          _this.form.image = img[0].sattDir;
          // _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '3' && !num) {
          _this.form.flatPattern = img[0].sattDir;
          // _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '2' && !num) {
          if (img.length > 10) return this.$message.warning('最多选择10张图片！');
          if (img.length + _this.form.sliderImages.length > 10) return this.$message.warning('最多选择10张图片！');
          img.map(function (item) {
            _this.form.sliderImages.push(item.sattDir);
          });
        }
        if (tit === '1' && num === 'dan') {
          _this.OneattrValue[0].image = img[0].sattDir;
        }
        if (tit === '1' && num === 'duo') {
          _this.ManyAttrValue[i].image = img[0].sattDir;
        }
        if (tit === '1' && num === 'pi') {
          _this.oneFormBatch[0].image = img[0].sattDir;
        }
      }, tit, 'content');
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      if (!this.isDisabled) this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      if (!this.isDisabled) this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      if (!this.isDisabled) e.dataTransfer.dropEffect = 'move';
    },
    // 移动关键代码，包含轮播图、规格
    handleDragEnter: function handleDragEnter(e, item, index) {
      if (!this.isDisabled) {
        var _newItems;
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = [];
        newItems = _toConsumableArray(this.form.sliderImages);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        (_newItems = newItems).splice.apply(_newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.form.sliderImages = newItems;
      }
    }
  }
};